module.exports = __webpack_public_path__ + "static/media/nav-payment-red.65d51fb6.svg";